import { render, staticRenderFns } from "./SMSCharacterCounter.vue?vue&type=template&id=40767430&scoped=true&"
import script from "./SMSCharacterCounter.vue?vue&type=script&lang=js&"
export * from "./SMSCharacterCounter.vue?vue&type=script&lang=js&"
import style0 from "./SMSCharacterCounter.vue?vue&type=style&index=0&id=40767430&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40767430",
  null
  
)

export default component.exports